import React from "react"
import { ButtonBase, Divider, Typography } from "@mui/material"
import { ButtonLoadingSeeker, IconSeeker } from "@ui-seeker/core"

import { dsColorNew } from "@palette"


// A secondary action beside the blue one: white with a thin border (download an example, upload a file…)
export const secondaryButtonSx = {
	height: 38, px: 2, borderRadius: '8px', textTransform: 'none', fontSize: 14, boxShadow: 'none',
	color: dsColorNew.textDark, border: `1px solid ${dsColorNew.grayBorder}`, backgroundColor: dsColorNew.white,
	'&:hover': { borderColor: dsColorNew.appBlue, backgroundColor: dsColorNew.hoverBgLight, boxShadow: 'none' },
}

// An icon action in the page header (copy link, save…): a 40px outlined square as the header fields, grey icon, app blue on hover
export const headerIconButtonSx = {
	width: 40, height: 40, p: 0, borderRadius: '8px', border: `1px solid ${dsColorNew.grayBorder}`,
	color: dsColorNew.textMuted, backgroundColor: dsColorNew.white,
	'& *': { color: 'inherit' },
	fontSize: 16,
	'&:hover': { borderColor: dsColorNew.appBlue, color: dsColorNew.appBlue, backgroundColor: dsColorNew.hoverBgLight },
}

// The "create" action at the end of a table toolbar: a thin rule, then the blue button
export default function AppToolbarCreateButton({ label = 'Create', icon = 'plus', divider = true, sx = {}, ...props }) {
	return <>
		{divider && <Divider orientation="vertical" flexItem sx={{ my: 1, ml: 1, mr: 1.5 }}/>}
		<ButtonLoadingSeeker
			startIcon={<IconSeeker icon={icon}/>}
			{...props}
			sx={{
				whiteSpace: 'nowrap',
				backgroundColor: dsColorNew.appBlue,
				boxShadow: 'none',
				'&:hover': { backgroundColor: dsColorNew.appBlueHover, boxShadow: 'none' },
				...sx,
			}}
		>
			{label}
		</ButtonLoadingSeeker>
	</>
}

// A filter that switches on and off with a click: soft blue while on
export function AppFilterChip({ label, icon, selected = false, iconSx = {}, sx = {}, ...props }) {
	return <ButtonBase
		aria-pressed={selected}
		{...props}
		sx={{
			gap: 0.75, px: 1.25, height: 30, borderRadius: '8px',
			border: `1px solid ${selected ? dsColorNew.appBlue : dsColorNew.grayBorder}`,
			backgroundColor: selected ? dsColorNew.pillActiveBg : dsColorNew.white,
			transition: 'all 0.15s ease',
			'&:hover': { borderColor: dsColorNew.appBlue },
			'&.Mui-focusVisible': { outline: `2px solid ${dsColorNew.webBlue500}`, outlineOffset: 1 },
			...sx,
		}}
	>
		{!!icon && <IconSeeker icon={icon} sx={{ fontSize: 13, ...iconSx, ...(selected && { color: dsColorNew.appBlue }) }}/>}
		<Typography component="span" sx={{ fontSize: 13, fontWeight: selected ? 600 : 500, color: selected ? dsColorNew.appBlue : dsColorNew.textDark, whiteSpace: 'nowrap', userSelect: 'none' }}>
			{label}
		</Typography>
	</ButtonBase>
}
